(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9656],{

/***/ 5361:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo",
      function () {
        return __webpack_require__(9937);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _icons_spinner_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8374);




const FullPageLoader = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(" flex h-full items-center justify-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-primary-500 flex items-center rounded-lg px-4 py-3 text-sm text-white shadow-sm",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons_spinner_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: "mr-3 h-5 animate-spin"
                }),
                children
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FullPageLoader);


/***/ }),

/***/ 7348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NA": function() { return /* binding */ withSession; },
/* harmony export */   "aF": function() { return /* binding */ useUser; },
/* harmony export */   "wF": function() { return /* binding */ isUnclaimed; }
/* harmony export */ });
/* unused harmony exports UserContext, useAuthenticatedUser, IfAuthenticated, IfGuest, UserProvider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(692);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3742);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3757);
/* harmony import */ var _use_required_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8355);
/* provided dependency */ var process = __webpack_require__(3454);







const UserContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.createContext(null);
const useUser = ()=>{
    return (0,_use_required_context__WEBPACK_IMPORTED_MODULE_5__/* .useRequiredContext */ .a)(UserContext, "UserContext");
};
const useAuthenticatedUser = ()=>{
    const { user , ...rest } = useRequiredContext(UserContext, "UserContext");
    if (user.isGuest) {
        throw new Error("Forget to prefetch user identity");
    }
    return {
        user,
        ...rest
    };
};
const IfAuthenticated = (props)=>{
    const { user  } = useUser();
    if (user.isGuest) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
const IfGuest = (props)=>{
    const { user  } = useUser();
    if (!user.isGuest) {
        return null;
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
const UserProvider = (props)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("app");
    const queryClient = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.useContext */ .G.useContext();
    const { data: user  } = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.whoami.get.useQuery */ .G.whoami.get.useQuery();
    const [isUpdating, setIsUpdating] = react__WEBPACK_IMPORTED_MODULE_3__.useState(false);
    const logout = _utils_trpc__WEBPACK_IMPORTED_MODULE_4__/* .trpcNext.whoami.destroy.useMutation */ .G.whoami.destroy.useMutation({
        onSuccess: async ()=>{
            setIsUpdating(true);
            await queryClient.whoami.invalidate();
            setIsUpdating(false);
        }
    });
    (0,react_use__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(()=>{
        var _process_env_NEXT_PUBLIC_POSTHOG_API_KEY;
        posthog_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].init */ .ZP.init((_process_env_NEXT_PUBLIC_POSTHOG_API_KEY = process.env.NEXT_PUBLIC_POSTHOG_API_KEY) !== null && _process_env_NEXT_PUBLIC_POSTHOG_API_KEY !== void 0 ? _process_env_NEXT_PUBLIC_POSTHOG_API_KEY : "fake token", {
            api_host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
            opt_out_capturing_by_default: false,
            capture_pageview: false,
            capture_pageleave: false,
            autocapture: false,
            loaded: (posthog)=>{
                if (!process.env.NEXT_PUBLIC_POSTHOG_API_KEY) {
                    posthog.opt_out_capturing();
                }
                if (user && posthog.get_distinct_id() !== user.id) {
                    posthog.identify(user.id, !user.isGuest ? {
                        email: user.email,
                        name: user.name
                    } : {
                        name: user.id
                    });
                }
            }
        });
    });
    const shortName = user ? user.isGuest === false ? user.name : user.id.substring(0, 10) : t("guest");
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserContext.Provider, {
        value: {
            isUpdating,
            user: {
                ...user,
                shortName
            },
            refresh: ()=>{
                return queryClient.whoami.invalidate();
            },
            ownsObject: (param)=>{
                let { userId  } = param;
                if (userId && user.id === userId) {
                    return true;
                }
                return false;
            },
            logout: ()=>{
                logout.mutate();
            }
        },
        children: props.children
    });
};
// eslint-disable-next-line @typescript-eslint/ban-types
const withSession = (component)=>{
    const ComposedComponent = (props)=>{
        const Component = component;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UserProvider, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            })
        });
    };
    ComposedComponent.displayName = "withUser(".concat(component.displayName, ")");
    return ComposedComponent;
};
/**
 * @deprecated Stop using this function. All object
 */ const isUnclaimed = (obj)=>!obj.userId;


/***/ }),

/***/ 9937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692);
/* harmony import */ var posthog_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3742);
/* harmony import */ var _components_full_page_loader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13);
/* harmony import */ var _components_user_provider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7348);
/* harmony import */ var _utils_trpc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3757);









const Demo = ()=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("app");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const createDemo = _utils_trpc__WEBPACK_IMPORTED_MODULE_7__/* .trpc.useMutation */ .S.useMutation([
        "polls.demo.create"
    ]);
    (0,react_use__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(async ()=>{
        const urlId = await createDemo.mutateAsync();
        posthog_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].capture */ .ZP.capture("create demo poll");
        router.replace("/admin/".concat(urlId));
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_full_page_loader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: t("creatingDemo")
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_user_provider__WEBPACK_IMPORTED_MODULE_6__/* .withSession */ .NA)(Demo));


/***/ }),

/***/ 3742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_useMount; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/react-use/esm/useEffectOnce.js

var useEffectOnce = function (effect) {
    (0,react.useEffect)(effect, []);
};
/* harmony default export */ var esm_useEffectOnce = (useEffectOnce);

;// CONCATENATED MODULE: ./node_modules/react-use/esm/useMount.js

var useMount = function (fn) {
    esm_useEffectOnce(function () {
        fn();
    });
};
/* harmony default export */ var esm_useMount = (useMount);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [160,9774,2888,179], function() { return __webpack_exec__(5361); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);